import { PLANS } from '../constants/content';
import { openZohoChat } from '../utils/openZohoChat';

export default function Pricing() {
  return (
    <section className="fm-section fm-section--alt" id="pricing">
      <div className="fm-container">
        <div className="fm-sec-head">
          <p className="fm-kicker">Pricing</p>
          <h2 className="fm-sec-title">Simple pricing for every stage</h2>
          <p className="fm-sec-lead">
            Start with one seat, share with your studio, or request enterprise
            terms as you scale.
          </p>
        </div>
        <div className="fm-plan-grid">
          {PLANS.map((plan) => (
            <article
              key={plan.name}
              className={`fm-plan${plan.featured ? ' fm-plan--featured' : ''}`}
            >
              <h3>{plan.name}</h3>
              <p className="fm-plan__price">{plan.price}</p>
              <p className="fm-plan__detail">{plan.detail}</p>
              <ul>
                {plan.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
              <button
                type="button"
                className={`fm-btn fm-btn--block ${
                  plan.featured ? 'fm-btn--primary' : 'fm-btn--outline'
                }`}
                onClick={openZohoChat}
              >
                {plan.price === 'Custom' ? 'Chat with sales' : 'Chat to get started'}
              </button>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
